<template>
  <div class="questionBankAdminDetails">
    <!-- <span class="el-icon-house"> / 题库管理 / 题目管理</span> -->
    <div class="backStyle">
      <el-page-header content="题目管理" @back="goback"></el-page-header>
    </div>
    <div class="questionBankAdminDetailsMain">
      <div class="questionBankAdminDetailsTop">
        <el-form :inline="true" :model="formInline" size="mini" style="margin-top: 10px;">
          <el-form-item label="题目名称">
            <el-input @keyup.enter.native="search" v-model="formInline.title" placeholder="题目名称" clearable @change="search" style="width:200px"></el-input>
          </el-form-item>

          <el-form-item label="知识分组">
            <el-select style="width:200px;" @change="Filterpoints" v-model="formInline.question_group_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionTagGroupList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="知识点">
            <el-select style="width:200px;" @change="search" :disabled="isShow" v-model="formInline.question_tag_id" filterable placeholder="请选择" clearable>
              <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button style="margin-left:10px;" type="primary" size="mini" @click="goNext">新建题目</el-button>

            <el-button style="margin-left:10px;" type="primary" size="mini" @click="ChooseQuestion">选择题目</el-button>
          </el-form-item>

          <el-button plain icon="el-icon-caret-right" style="float:right" size="mini" v-if="isShowQuestion == false ? true : false" @click="changeAll">展开</el-button>
          <el-button plain icon="el-icon-caret-bottom" style="float:right" @click="changeAll1" size="mini" v-if="isShowQuestion == true ? true : false">收起</el-button>

          <br />
          <el-form-item label="题目类型">
            <el-radio-group @change="search" v-model="formInline.type">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">单选题</el-radio>
              <el-radio label="2">多选题</el-radio>
              <el-radio label="3">判断题</el-radio>
              <el-radio label="4">填空题</el-radio>
              <el-radio label="5">简答题</el-radio>
              <el-radio label="6">综合题</el-radio>
              <el-radio label="7">阅读程序</el-radio>
              <el-radio label="8">完善程序</el-radio>
              <el-radio label="9">编程题</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div style="margin-top: 0px;">
        <div>
          <el-table :row-key="(row) => row.id" :expand-row-keys="expandedRows" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe :data="tableData" style="width: 100%;margin-top: 0px;">
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding:20px;">
                  <div v-if="props.row.show_type === 1">
                    <div class="question_title" v-html="props.row.title"></div>
                  </div>
                  <div class="question_title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </div>

                  <div v-if="props.row.show_type === 1">
                    <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                      <div v-if="props.row.type != '6'">
                        <div v-if="item.content" class="options_title">
                          {{ item.title }}
                        </div>

                        <div v-if="item.content" class="options_content">
                          <div class="content" v-html="item.content"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="props.row.type == '3'">
                      <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                        <div style="padding: 15px;">
                          <div v-if="item.content" class="options_title">
                            {{ item.title }}
                          </div>

                          <div v-if="item.content" class="options_content">
                            <div class="content" v-html="item.content"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="options" v-for="(item, index) of JSON.parse(props.row.options_md)" :key="index">
                      <div style="padding: 15px;">
                        <div v-if="item.content" class="options_title">
                          {{ item.title }}
                        </div>

                        <div v-if="item.content" class="options_content">
                          <div class="content">
                            <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#F5F7FC" v-model="item.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="answer">
                    <span class="answer_label">正确答案:</span>
                    <span v-if="
                        props.row.type == '1' ||
                          props.row.type == '2' ||
                          props.row.type == '3' ||
                          props.row.type == '4' ||
                          props.row.type == '7' ||
                          props.row.type == '8'
                      " class="answer_content" v-html="props.row.answer"></span>
                    <span v-else-if="props.row.type == '5'">简答题答案</span>
                    <span v-else-if="props.row.type == '6'">综合题答案</span>
                  </div>

                  <div class="analysis">
                    <span class="analysis_label">试题解析:</span>
                    <span v-if="props.row.show_type === 1" class="answer_content" v-html="props.row.analysis"></span>
                    <span v-else class="answer_content">
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column width="50" align="center" label="序号" fixed="left">
              <template slot-scope="scope">{{
                scope.$index + 1 + 20 * (formInline.page_no - 1)
              }}</template>
            </el-table-column>

            <el-table-column label="题型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">单选</span>
                <span v-if="scope.row.type == 2">多选</span>
                <span v-if="scope.row.type == 3">判断</span>
                <span v-if="scope.row.type == 4">填空</span>
                <span v-if="scope.row.type == 5">简答</span>
                <span v-if="scope.row.type == 6">综合题</span>
                <span v-if="scope.row.type == 7">阅读程序</span>
                <span v-if="scope.row.type == 8">完善程序</span>
                <span v-if="scope.row.type == 9">编程题</span>
              </template>
            </el-table-column>

            <el-table-column label="格式" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.show_type === 1">富文本</span>
                <span v-if="scope.row.show_type === 2">MD</span>
              </template>
            </el-table-column>

            <el-table-column label="题干描述" width="200">
              <template slot-scope="scope">
                <div v-if="scope.row.title_other_md" class="ellipsis" v-html="scope.row.title_other_md"></div>
                <div v-else>--</div>
              </template>
            </el-table-column>

            <el-table-column label="题目名称" width="300">
              <template slot-scope="scope">
                <div class="ellipsis">{{ scope.row.title_str }}</div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="知识点">
              <template slot-scope="scope">
                <span>{{ scope.row.tagTitleStr }}</span>
              </template>
            </el-table-column>

            <el-table-column label="排序号" prop="sort_num" width="100">
              <template slot-scope="scope">
                <el-link type="primary" style="cursor:pointer;" @click="EditQuestionSort(scope.row.id, scope.row.sort_num)">{{ scope.row.sort_num }}</el-link>
              </template>
            </el-table-column>

            <el-table-column label="Code" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.code_other">
                  {{ scope.row.code_other }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="重复题标记" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.bulk_operate_code }}</span>
              </template>
            </el-table-column>

            <el-table-column label="所属题库" width="150">
              <template slot-scope="scope">
                <el-popover placement="top-start" :title="scope.row.bankInfo.title" trigger="hover" :content="
                    '来源:' +
                      (scope.row.bankInfo.sourceTitle
                        ? scope.row.bankInfo.sourceTitle
                        : '--') +
                      ' 年份:' +
                      (scope.row.bankInfo.yearTitle
                        ? scope.row.bankInfo.yearTitle
                        : '--') +
                      ' 科目:' +
                      scope.row.subjectName
                  ">
                  <span slot="reference">{{ scope.row.bankInfo.title }}</span>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="150" fixed="right">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.type == 7 || scope.row.type == 8">
                                    <el-link type="primary" @click="EditQuestion(scope.row)"
                                        :disabled="scope.row.educational_institution_id != null">操作</el-link>
                                </span> -->
                <!-- <span v-else> -->
                <el-link type="primary" @click="EditQuestion(scope.row)" :disabled="scope.row.educational_institution_id != null">编辑</el-link>
                <el-link style="margin-left: 10px;" type="primary" @click="DeleteQuestion(scope.row.id)" :disabled="scope.row.educational_institution_id != null">删除</el-link>
                <!-- </span> -->
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 5px;">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.page_no" layout="total, prev, pager, next" :page-size="20" :total="formInline.total"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div v-for="(item, index) in tableData1" :key="index" class="questionBankAdminList">
        <div style="overflow: hidden;">
          <div class="fl" style="width: 35px; height: 45px;border: 1px solid #ccc;"></div>
          <div class="fl" style="margin-left: 20px;">
            <div style="font-weight:bold;">{{ item.title }}</div>
            <div style="font-weight:bold; margin-top: 10px;">
              <div style="overflow: hidden;">
                <div class="fl" style="margin-left: 10px;">
                  共 {{ item.num }} 题
                </div>
                <div class="fl" style="margin-left: 10px;">
                  <el-tag type="info" size="mini">{{ item.name1 }}</el-tag>
                </div>
              </div>
            </div>
          </div>
          <div class="fr" style="margin-top: 7px;">
            <el-button size="mini" type="primary">查看</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="adminUpdateQuestionSortNum">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改题目排序号-->
    <el-dialog title="题目排序号" :visible.sync="sortDialogVisible" width="300px">
      <el-input-number size="small" style="width:190px;" v-model="form.sort_num" :precision="1" :step="0.1"></el-input-number>
      <el-button style="margin-left:10px;" size="small" type="primary" @click="adminUpdateQuestionSortNum">保 存</el-button>
    </el-dialog>

    <el-drawer size="100%" :visible.sync="drawer" :with-header="false" direction="ltr">
      <div style="padding:10px;border-bottom:1px solid #f5f7fa;">
        <span style="font-weight: bold;font-size:18px;">添加题目</span>
        <el-button @click="CloseDrawer" style="float:right" size="mini">✕</el-button>
      </div>

      <div style="padding: 20px;">
        <el-form :inline="true" :model="formInline1" size="mini">
          <el-form-item label="题目名称">
            <el-input @change="search1" style="width: 400px;" @keyup.enter.native="search1" v-model="formInline1.title_str" placeholder="请输入题目名称" clearable></el-input>
          </el-form-item>

          <el-form-item label="Code值">
            <el-input style="width:300px;" @keyup.enter.native="search1" v-model="formInline1.code_other" placeholder="请输入题目code值" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search1">查询</el-button>
          </el-form-item>

          <el-form-item label="">
            <el-checkbox style="margin-left:20px;" @change="search1" v-model="formInline1.exclude_duplication">过滤重复题</el-checkbox>
          </el-form-item>

          <el-form-item style="float:right;right:0px;">
            <el-button type="danger" @click="ExceptQuestion">排除已有题目</el-button>
          </el-form-item>

          <br />

          <el-form-item label="年份">
            <el-select @change="search1" style="width: 130px;" v-model="formInline1.year_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankYearList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题目来源">
            <el-select @change="changesource" v-model="formInline1.source_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道/分项">
            <el-select @change="search1" v-model="formInline1.source_tag_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属科目">
            <el-select :disabled="!true" @change="changeSubject" style="width: 130px;" v-model="formInline1.subject_id" placeholder="请选择" clearable>
              <el-option v-for="item in subject_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="知识分组">
            <el-select v-model="formInline1.question_group_id" placeholder="请选择" clearable @change="adminGetTestQuestionTagListWithoutPage1">
              <el-option v-for="item in testQuestionTagGroupList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="知识点">
            <el-select @change="search1" style="width: 130px;" v-model="formInline1.question_tag_id" placeholder="请选择" clearable filterable>
              <el-option v-for="item in testQuestionTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <br />
          <el-form-item label="题目类型">
            <el-radio-group @change="search1" v-model="formInline1.type">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">单选题</el-radio>
              <el-radio label="2">多选题</el-radio>
              <el-radio label="3">判断题</el-radio>
              <el-radio label="4">填空题</el-radio>
              <el-radio label="5">简答题</el-radio>
              <el-radio label="6">综合题</el-radio>
              <el-radio label="7">阅读程序</el-radio>
              <el-radio label="8">完善程序</el-radio>
              <!-- 这里不要OJ题 -->
              <!-- <el-radio label="9">编程题</el-radio> -->
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-table :data="tableData2" :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }" stripe style="width: 100%;" size="small">
          <el-table-column prop="sort_num" label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (page_no1 - 1) * page_size1 }}
            </template>
          </el-table-column>

          <el-table-column prop="subjectName" label="科目" width="80">
          </el-table-column>
          <el-table-column prop="" label="题型" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">单选</span>
              <span v-if="scope.row.type == 2">多选</span>
              <span v-if="scope.row.type == 3">判断</span>
              <span v-if="scope.row.type == 4">填空</span>
              <span v-if="scope.row.type == 5">简答</span>
              <span v-if="scope.row.type == 6">综合题</span>
              <span v-if="scope.row.type == 7">阅读程序</span>
              <span v-if="scope.row.type == 8">完善程序</span>
              <span v-if="scope.row.type == 9">编程题</span>
            </template>
          </el-table-column>

          <el-table-column label="题干描述" width="200" v-if="formInline1.type == 7 || formInline1.type == 8">
            <template slot-scope="scope">
              <div v-if="scope.row.title_other_md" class="ellipsis" v-html="scope.row.title_other_md"></div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column label="题目名称" width="160">
            <template slot-scope="scope">
              <div class="ellipsis" v-html="scope.row.title_str"></div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tagTitleStr" label="知识点">
          </el-table-column>

          <el-table-column prop="bankInfo.sourceTitle" label="来源">
          </el-table-column>
          <el-table-column prop="bankInfo.tagRelationTitleStr" label="分项">
          </el-table-column>

          <el-table-column prop="bankInfo.yearTitle" label="年份" width="100">
          </el-table-column>

          <el-table-column label="Code" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.code_other">
                {{ scope.row.code_other }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column prop="bulk_operate_code" label="重复题标记">
          </el-table-column>

          <el-table-column label="所属题库" width="150">
            <template slot-scope="scope">
              <el-popover placement="top-start" :title="scope.row.bankInfo.title" trigger="hover" :content="
                  '来源:' +
                    (scope.row.bankInfo.sourceTitle
                      ? scope.row.bankInfo.sourceTitle
                      : '--') +
                    ' 年份:' +
                    (scope.row.bankInfo.yearTitle
                      ? scope.row.bankInfo.yearTitle
                      : '--') +
                    ' 科目:' +
                    scope.row.subjectName
                ">
                <span slot="reference">{{ scope.row.bankInfo.title }}</span>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100">
            <template slot-scope="scope" :name="scope.row.id">
              <el-button type="text" size="mini" @click="Preview(scope.row)">预览</el-button>
              <el-button type="text" size="mini" style="margin-left: 10px;" @click="adminCopyQuestionToBank(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 5px;">
          <el-pagination @current-change="handleCurrentChange1" :current-page.sync="page_no1" layout="total, prev, pager, next" :total="total1" :page-size="page_size1"></el-pagination>
        </div>
      </div>
    </el-drawer>

    <el-drawer size="50%" :visible.sync="drawer1" :with-header="false">
      <div style="margin-top: 10px;padding: 20px;">
        <div style="border-radius: 5px;">
          <div style="font-weight: bold;font-size: 16px;">
            题目信息 ( code:
            <span v-if="questionRow.code_other">
              {{ questionRow.code_other.substring(0, 4) }}</span>
            <span v-else>--</span>
            )
          </div>

          <div v-if="questionRow.title_other_md" style="margin-top: 10px;" v-html="questionRow.title_other_md"></div>

          <div style="margin-top: 10px;">
            <div v-if="questionRow.show_type === 1">
              <div class="question_title" v-html="questionRow.title"></div>
            </div>
            <div class="question_title" v-else>
              <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="questionRow.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
            </div>
          </div>
          <div>
            <div v-if="questionRow.show_type === 1">
              <div class="options" v-for="(item, index) of JSON.parse(questionRow.options)" :key="index">
                <div v-if="questionRow.type != '6'">
                  <div v-if="item.content" class="options_title">
                    {{ item.title }}
                  </div>

                  <div v-if="item.content" class="options_content">
                    <div class="content" v-html="item.content"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="questionRow.type == '3'">
                <div v-if="questionRow.options">
                  <div class="options" v-for="(item, index) of JSON.parse(questionRow.options)" :key="index">
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content" v-html="item.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="questionRow.options_md">
                  <div class="options" v-for="(item, index) of JSON.parse(questionRow.options_md)" :key="index">
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content">
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px;">
            <div class="answer_label">正确答案:</div>
            <div v-if="
                questionRow.type == '1' ||
                  questionRow.type == '2' ||
                  questionRow.type == '3' ||
                  questionRow.type == '4'
              " class="answer_content" v-html="questionRow.answer"></div>
            <div v-else-if="questionRow.type == '5'">简答题答案</div>
            <div v-else-if="questionRow.type == '6'">综合题答案</div>
          </div>

          <div style="margin-top: 10px;">
            <div class="answer_label">试题解析:</div>
            <div v-if="questionRow.show_type === 1" class="answer_content" v-html="questionRow.analysis"></div>
            <div v-else class="answer_content">
              <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="questionRow.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!--排除题库列表-->
    <el-drawer :visible.sync="showexception" direction="ltr" size="80%" :with-header="false" :show-close="true" @close="ClosedQuestionBack">
      <div style="padding:20px 20px 0px 20px;">
        <el-form :inline="true" :model="formInline2" size="small">
          <el-form-item label="题库名称">
            <el-input style="width:300px;" @keyup.enter.native="search2" v-model="formInline2.title" placeholder="请输入题库名称" clearable @change="search2"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search2">查询</el-button>
          </el-form-item>
          <br />

          <el-form-item label="年份">
            <el-select style="width:200px;" @change="search2" v-model="formInline2.year_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankYearList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题库来源">
            <el-select style="width:200px;" @change="search2" v-model="formInline2.source_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道/分项">
            <el-select @change="search2" style="width:200px;" v-model="formInline2.source_tag_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="真题/集训方案">
            <el-select @change="search2" style="width:150px;" v-model="formInline2.match_bank_type" placeholder="请选择" clearable>
              <el-option v-for="item in matchBankTypeList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div></div>
        </el-form>
      </div>

      <div style="padding:0px 20px 0px 20px">
        <el-table size="small" :data="tableData3" :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }" stripe height="60vh" ref="multipleTable" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column align="center" width="80" label="封面">
            <template slot-scope="scope">
              <el-image style="width: 37.5px; height: 17px;border-radius: 2px;" :src="scope.row.cover_url" fit="fill"></el-image>
            </template>
          </el-table-column>

          <el-table-column align="left" width="200" label="题库名称" prop="title">
          </el-table-column>

          <el-table-column align="left" label="科目" prop="subjectName">
          </el-table-column>

          <el-table-column align="left" label="年份">
            <template slot-scope="scope">
              <span>{{ scope.row.yearTitle }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="来源" prop="">
            <template slot-scope="scope">
              <span v-if="scope.row.sourceInfo != null">{{
                scope.row.sourceInfo.title
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="分项">
            <template slot-scope="scope">
              <span v-if="scope.row.tagRelationInfoArr.length > 0">
                {{ scope.row.tagRelationInfoArr[0].tagInfo.title }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="真题/集训" width="150">
            <template slot-scope="scope">
              <span>{{
                scope.row.match_bank_type === 1 ? '真题' : '集训'
              }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="题数" prop="question_num">
          </el-table-column>

          <el-table-column v-if="formInline.is_admin == '2'" align="left" label="所属校区" prop="schoolName">
          </el-table-column>

          <el-table-column align="center" label="发布状态">
            <template slot-scope="scope">
              <span style="color:grey;" v-if="scope.row.post_state == 2">
                未发布
              </span>
              <span style="color:green;" v-if="scope.row.post_state == 1">
                已发布
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px;">
        <div style="text-align: right;">
          <el-pagination @current-change="handleCurrentChange2" :current-page.sync="formInline2.page_no" layout="total, prev, pager, next" :total="formInline2.total" :page-size="formInline2.page_size"></el-pagination>
        </div>
      </div>

      <div style="padding:0px 20px 20px 20px">
        <div>
          已选题库
          <span style="margin-left:10px;cursor: pointer;" @click="ClearData">清除</span>
        </div>
        <div>
          <el-tag size="mini" style="margin:10px;" v-for="tag in SelectedQuestionBank" :key="tag.title" closable type="info" @close="handleCloseTag(tag)">
            {{ tag.title }}
          </el-tag>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  adminGetTestQuestionTagListWithoutPage, //知识点
  adminGetQuestionList,
  adminDeleteQuestion,
  adminGetUniqueSubjectList,
  adminGetTestQuestionTagGroupListWithoutPage,
  adminUpdateQuestionSortNum,
  adminGetTestQuestionBankSourceTagListWithoutPage, //分项
  adminGetTestQuestionBankSourceListWit, //来源
  adminGetTestQuestionBankYearListWithoutPage, //年份
  getSubjectList,
  adminGetTestQuestionListForBankAddQuestion,
  adminCopyQuestionToBank,
  adminGetQuestionBankList,
} from '@/api/admin.js'

export default {
  name: 'questionBankAdminDetails',
  data() {
    return {
      dialogVisible: false,
      tableData1: [],
      tableData: [],
      activeIndex: 0,
      formInline: {
        type: '',
      },
      bankTotalQuestionNum: 0,
      options: [],
      options1: [],
      subjectList: [],
      page_no: 1,
      page_size: 10,
      total: 0,
      testQuestionTagGroupList: [],
      isShow: true,
      isShowQuestion: false,
      expandedRows: [],

      //单独修改排序号
      form: {
        question_id: '',
        sort_num: '',
      },
      sortDialogVisible: false,

      //添加题目
      drawer: false,
      formInline1: {
        question_group_id: '',
        subject_id: '',
        question_tag_id: '',
        type: '',
        code_other: '',
        page_no: 1,
        page_size: 20,
        total: 0,
        exclude_duplication: true,
      },

      //排除已有题库题目筛选条件
      formInline2: {
        title: '',
        year_id: '',
        source_tag_id: '',
        source_id: '',
        match_bank_type: '',
        is_admin: '1',
        page_no: 1,
        page_size: 20,
        total: 0,
      },

      testQuestionTagList: [],
      testQuestionBankYearList: [],
      testQuestionBankSourceList: [],
      testQuestionBankSourceTagList: [],
      subject_list: [],

      page_no1: 1,
      page_size1: 20,
      total1: 0,
      tableData2: [],
      drawer1: false, //题目预览
      questionRow: {},

      showexception: false,

      matchBankTypeList: [
        { title: '真题', id: '1' },
        { title: '集训方案', id: '2' },
      ],
      tableData3: [], //需要排除的题库
      SelectedQuestionBank: [], //已经选择的题库
      SelectedBankIds: [],
    }
  },

  mounted() {
    if (
      JSON.parse(
        sessionStorage.getItem('testing_questionBankAdminDetails_formInline')
      )
    ) {
      this.formInline = JSON.parse(
        sessionStorage.getItem('testing_questionBankAdminDetails_formInline')
      )
    }
    this.formInline1.subject_id = Number(this.$route.query.subject_id)
    this.adminGetTestQuestionTagListWithoutPage()
    this.adminGetQuestionList()
    this.adminGetUniqueSubjectList()
    this.adminGetTestQuestionTagGroupListWithoutPage()
    this.adminGetTestQuestionTagListWithoutPage1()
  },

  watch: {
    formInline: {
      handler(newVal, oldVal) {
        // 当 formInline 对象的任何属性发生变化时执行的回调函数
        console.log('formInline 值发生变化', newVal, oldVal)

        console.log('新值')
        console.log(newVal)

        sessionStorage.setItem(
          'testing_questionBankAdminDetails_formInline',
          JSON.stringify(newVal)
        )
      },
      deep: true, // 开启深度监听，用于监听 formInline 对象属性的值变化
    },
  },

  methods: {
    ClosedQuestionBack() {
      console.log('窗口关闭')
      this.search1()
    },

    ClearData() {
      this.SelectedBankIds = []
      this.SelectedQuestionBank = []
    },

    handleCloseTag(tag) {
      console.log(tag)

      this.SelectedQuestionBank = this.SelectedQuestionBank.filter(
        (item) => item.id !== tag.id
      )

      this.SelectedBankIds = []
      for (let i = 0; i < this.SelectedQuestionBank.length; i++) {
        this.SelectedBankIds.push(this.SelectedQuestionBank[i].id)
      }
    },

    handleSelectionChange(val) {
      console.log('选择题目变化')
      console.log(val)
      const mergedArray = [...this.SelectedQuestionBank] // 创建一个副本存放合并后的数组

      val.forEach((item) => {
        const existingItem = mergedArray.find(
          (existing) => existing.id === item.id
        )
        if (!existingItem) {
          mergedArray.push(item)
        }
      })

      this.SelectedQuestionBank = mergedArray

      this.SelectedBankIds = []
      for (let i = 0; i < this.SelectedQuestionBank.length; i++) {
        this.SelectedBankIds.push(this.SelectedQuestionBank[i].id)
      }

      console.log('ID组')
      console.log(this.SelectedBankIds)
    },

    ExceptQuestion() {
      console.log('排除已有题目')
      this.showexception = true
      if (this.SelectedBankIds.length == 0) {
        this.adminGetQuestionBankList()
      }
    },

    adminGetQuestionBankList() {
      adminGetQuestionBankList({
        title: this.formInline2.title,
        subject_id: this.formInline1.subject_id,
        year_id: this.formInline2.year_id,
        source_tag_id: this.formInline2.source_tag_id, //分项列表
        source_id: this.formInline2.source_id, //来源ID
        is_admin: '1',
        match_bank_type: this.formInline2.match_bank_type,
        page_no: this.formInline2.page_no,
        page_size: this.formInline2.page_size,
      }).then((res) => {
        console.log('题库信息')
        console.log(res)

        this.tableData3 = res.questionBankList
        this.formInline2.total = res.total
      })
    },

    Preview(row) {
      this.questionRow = row
      console.log(this.questionRow, 1235456)
      this.drawer1 = true
    },

    adminCopyQuestionToBank(val) {
      console.log('添加题目')
      console.log(val)

      console.log(val.id)
      console.log(this.$route.query.id)

      adminCopyQuestionToBank({
        questionId: val.id,
        questionBankId: this.$route.query.id,
      }).then((res) => {
        console.log(res)
        if (res.is_created) {
          this.$message.success('添加成功')
          this.search1(true)
        }
      })
    },

    search1(savePage = false) {
      if (!savePage) {
        this.page_no1 = 1
      }
      this.adminGetTestQuestionListForBankAddQuestion()
    },

    search2() {
      this.formInline2.page_no = 1
      this.adminGetQuestionBankList()
    },

    adminGetTestQuestionListForBankAddQuestion() {
      console.log('当前科目')
      console.log(this.formInline1.subject_id)

      adminGetTestQuestionListForBankAddQuestion({
        bank_id: this.$route.query.id,
        title_str: this.formInline1.title_str,
        source_id: this.formInline1.source_id,
        source_tag_id: this.formInline1.source_tag_id,
        year_id: this.formInline1.year_id,
        subject_id: this.formInline1.subject_id,
        question_group_id: this.formInline1.question_group_id,
        question_tag_id: this.formInline1.question_tag_id,
        type: this.formInline1.type,
        code_other: this.formInline1.code_other,
        if_filter: this.formInline1.exclude_duplication,

        not_in_bank_id_arr: JSON.stringify(this.SelectedBankIds),
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('题目列表')
        console.log(res)
        this.tableData2 = res.questionList
        this.total1 = res.total
      })
    },

    //查询知识点
    adminGetTestQuestionTagListWithoutPage1() {
      adminGetTestQuestionTagListWithoutPage({
        group_id: this.formInline1.question_group_id,
        subject_id: this.$route.query.subject_id,
      }).then((res) => {
        console.log('知识点')
        console.log(res)
        this.formInline1.question_tag_id = ''
        this.testQuestionTagList = res.testQuestionTagList
        this.search1()
      })
    },

    //年份
    adminGetTestQuestionBankYearListWithoutPage() {
      adminGetTestQuestionBankYearListWithoutPage().then((res) => {
        console.log(res, 963333)
        this.testQuestionBankYearList = res.testQuestionBankYearList
      })
    },

    changesource(val) {
      this.formInline1.source_id = val
      this.adminGetTestQuestionBankSourceTagListWithoutPage()

      this.search1()
    },

    changeSubject(val) {
      this.formInline1.subject_id = val
      this.formInline1.question_group_id = '';
      this.formInline1.question_tag_id = '';
      this.adminGetTestQuestionTagGroupListWithoutPage()

      this.search1()
    },

    getSubjectList() {
      getSubjectList({
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.subject_list = res.subject_list
      })
    },

    //来源
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        console.log(res, 78945612)
        this.testQuestionBankSourceList = res.testQuestionBankSourceList
      })
    },
    //来源分项
    adminGetTestQuestionBankSourceTagListWithoutPage() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.formInline1.source_id,
      }).then((res) => {
        this.testQuestionBankSourceTagList = res.testQuestionBankSourceTagList
      })
    },

    //单独修改题目排序号
    adminUpdateQuestionSortNum() {
      adminUpdateQuestionSortNum({
        questionId: this.form.question_id,
        sort_num: this.form.sort_num,
      }).then((res) => {
        console.log('修改排序号')
        console.log(res)
        if (res.is_update) {
          this.$message.success('更新成功')
          this.search()
          this.sortDialogVisible = false
        }
      })
    },

    EditQuestionSort(id, sort_num) {
      this.form.sort_num = sort_num
      this.form.question_id = id
      this.sortDialogVisible = true
      console.log('排序号表单信息')
      console.log(this.form)
    },

    //展开题目和收起题目
    changeAll() {
      this.isShowQuestion = true
      this.expandedRows = this.tableData.map((row) => row.id)
      console.log(this.expandedRows)
    },
    changeAll1() {
      this.isShowQuestion = false
      this.expandedRows = []
      console.log(this.expandedRows)
    },

    Filterpoints(val) {
      console.log('切换知识点分组')
      console.log(val)
      this.adminGetTestQuestionTagListWithoutPage()
    },
    adminGetTestQuestionTagListWithoutPage() {
      adminGetTestQuestionTagListWithoutPage({
        group_id: this.formInline.question_group_id,
        subject_id: this.$route.query.subject_id,
      }).then((res) => {
        console.log('分组对应的知识点')
        console.log(res)
        this.options = res.testQuestionTagList
        if (res.testQuestionTagList.length > 0) {
          this.isShow = false
        } else {
          this.isShow = true
        }
      })
    },
    adminGetTestQuestionTagGroupListWithoutPage() {
      adminGetTestQuestionTagGroupListWithoutPage({
        subject_id: this.formInline1.subject_id,
        page_no: 1,
        page_size: 1000,
      }).then((res) => {
        console.log(res, 798465)
        this.testQuestionTagGroupList = res.testQuestionTagGroupList
        this.testQuestionTagList = [];
      })
    },
    goback() {
      sessionStorage.removeItem('testing_questionBankAdminDetails_formInline')

      this.$router.push({
        name: 'questionBankAdmin',
      })
    },
    adminGetUniqueSubjectList() {
      adminGetUniqueSubjectList({
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.subjectList = res.subject_list
        this.subjectList.unshift({ name: '全部' })
      })
    },
    EditQuestion(row) {
      console.log('编辑题目')
      console.log(row, 123465)

      this.$router.push({
        name: 'newQuestion',
        query: {
          id: this.$route.query.id,
          title: this.title,
          subject_id: row.subject_id,
          schoolId: row.educational_institution_id,
          type: '3',
          question_num: row.sort_num,
          code_other: row.code_other,
          typeIndex: 2,
        },
        params: {
          question: row,
        },
      })
      sessionStorage.setItem('ExamData', JSON.stringify(row))
    },
    DeleteQuestion(id) {
      console.log('删除题目')
      console.log(id)

      this.$confirm('确定删除本道题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        adminDeleteQuestion({
          questionId: id,
        }).then((res) => {
          console.log('删除题目')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.adminGetQuestionList()
          }
        })
      })
    },

    // handleExpandChange(row, expandedRows) {
    //     if (row.code_other) {
    //         if (expandedRows.length) {
    //             console.log(row, 78465456)
    //             console.log(expandedRows, 78465456)
    //             adminGetTestQuestionByBankIdAndCodeOther({
    //                 code_other: row.code_other
    //             }).then((res) => {
    //                 console.log(res, 78465456)
    //             })
    //         }

    //     }

    // },
    adminGetQuestionList() {
      adminGetQuestionList({
        questionBankId: this.$route.query.id,
        title_str: this.formInline.title,
        type: this.formInline.type,
        page_no: this.formInline.page_no,
        page_size: this.formInline.page_size,
        question_tag_id: this.formInline.question_tag_id,

        question_group_id: this.formInline.question_group_id,
      }).then((res) => {
        console.log('题目列表')
        console.log(res)
        this.formInline.total = res.total
        this.tableData = res.questionList
        this.bankTotalQuestionNum = res.bankTotalQuestionNum
      })
    },
    handleCurrentChange(val) {
      this.formInline.page_no = val
      this.adminGetQuestionList()
    },

    handleCurrentChange2(val) {
      console.log('当前页码')

      this.formInline2.page_no = val

      console.log(this.formInline2.page_no)

      this.adminGetQuestionBankList()
    },

    search() {
      this.formInline.page_no = 1
      this.adminGetQuestionList()
    },
    chengaName(val, index) {
      console.log(val)
      this.activeIndex = index
    },
    handleClose() {
      this.dialogVisible = false
    },
    btn() {
      this.dialogVisible = true
    },
    goNext() {
      this.$router.push({
        name: 'newQuestion',
        query: {
          id: this.$route.query.id,
          subject_id: this.$route.query.subject_id,
          question_num: this.bankTotalQuestionNum,
          typeIndex: 2,
        },
      })

      sessionStorage.removeItem('ExamData')
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.adminGetTestQuestionListForBankAddQuestion()
    },

    ChooseQuestion() {
      console.log('选择题目')
      this.drawer = true
      this.adminGetTestQuestionListForBankAddQuestion()
      this.adminGetTestQuestionBankYearListWithoutPage()
      this.adminGetTestQuestionBankSourceListWit()
      this.adminGetTestQuestionBankSourceTagListWithoutPage()
      this.formInline1.subject_id = Number(this.$route.query.subject_id)
      this.getSubjectList()
      this.adminGetTestQuestionTagGroupListWithoutPage()
    },

    CloseDrawer() {
      this.drawer = false
      this.adminGetQuestionList()
    },
  },
}
</script>

<style lang="scss" scoped>
.backStyle {
  // width:100%;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
}

.analysis {
  margin-top: 20px;

  .analysis_label {
    font-weight: 500;
  }
}

.answer {
  margin-top: 20px;
}

.answer_content {
  margin-top: 10px;
}

.answer_label {
  font-weight: bold;
}

.options_title {
  border-radius: 50%;
  background: #fff;
  float: left;
  text-align: center;
  width: 35px;
  height: 35px;
  line-height: 34px;
  margin: 10px;
}

.options_content {
  float: left;
  margin-left: 10px;
  line-height: 35px;
  margin: 10px 0;
}

.options {
  overflow: hidden;
  width: 100%;
  // padding: 15px;
  border-radius: 5px;
  background-color: #f5f7fc;
  margin-top: 15px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.questionBankAdminDetails {
  // margin: 10px;
  padding: 10px 10px 10px 10px;
}

.questionBankAdminDetailsMain {
  margin-top: 10px;
  background: white;
  border-radius: 5px;
  min-height: calc(100vh - 135px);
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.questionBankAdminDetailsTop {
  box-sizing: border-box;
}

.tagStyle {
  padding: 0px 7px;
  background-color: #f8f8f8;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}

.questionBankAdminListActive {
  background-color: #6da7f9;
  color: #fff;
}

.questionBankAdminList {
  width: 100%;
  padding: 20px;
  background: #f8f8f8;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 控制显示的最大行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
</style>
